module.exports = __webpack_public_path__ + "static/media/mcLogo.cadc4cd7.png";